/*
 * Copyright 2023, Corning Optical Communications
 * All Rights Reserved.
 */

import { createSlice } from "@reduxjs/toolkit";
import { setScheduledTaskAction, setActiveTaskStepAction, setIsEditTaskAction, setSelectedTaskAction, setSelectedTemplateAction } from "./actions";
import { initialState } from "./InitialState";

const searchSlice = createSlice({
  name: "tasks",
  initialState,
  reducers: {
    setScheduledTask: setScheduledTaskAction,
    setActiveTaskStep: setActiveTaskStepAction,
    setIsEditTask: setIsEditTaskAction,
    setSelectedTask: setSelectedTaskAction,
    setSelectedTemplate: setSelectedTemplateAction
  },
});

export const { setScheduledTask, setActiveTaskStep, setIsEditTask, setSelectedTask, setSelectedTemplate } = searchSlice.actions;

export const tasksReducer = searchSlice.reducer;
